import React from 'react'

import { useLocal } from '@/pages/dashboard/utils/customHook'
import { PanelList } from '../../constants'

const Footer = (props) => {
  const {
    value,
    isError,
    isShowBack,
    close,
    activePanel,
    onErrorChange,
    onSelectChange,
    onPanelChange
  } = props
  const { getLocalText } = useLocal('component_tracking_day')
  const result = value.replace('1-', '')

  const handleBackClick = () => {
    onPanelChange(PanelList.selectPanel)
  }

  const handleConfirm = () => {
    onSelectChange?.({id: result, name: result}, close)
  }
  
  return (
    <>
      {
        activePanel === PanelList.selectPanel ? (
          <span className='dtb-db-tracking-day__action' onClick={() => onPanelChange(PanelList.customizedPanel)}>{getLocalText('customize')}</span>
        ) : (
          <div className='dtb-db-tracking-day__btn-group'>
            <span
              className={`dtb-db-tracking-day__btn-primary ${(isError || value?.length <= 0) ? 'disabled' : ''}`}
              onClick={handleConfirm}
            >
              {getLocalText('confirm')}
            </span>
            {
              isShowBack && <span className='dtb-db-tracking-day__btn-primary' onClick={handleBackClick}>{getLocalText('back')}</span>
            }
          </div>
        )
      }
    </>
  )
}

export default Footer